<template>
	<div class="header">
		<el-header>
			<div class="head-left">
				<img class="image" src="@/assets/logo.png" />
				<span class="text">识圈</span>
				<!-- <el-tag class="tag" @click="goIndexView" v-if="$route == '/index/host'">管理后台</el-tag> -->
			</div>
			<div class="head-right">
				<el-tag class="tag" @click="goIndexView">{{leftTop}}</el-tag>
				<el-dropdown @command="handleCommand" trigger="click">
					<img class="img" :src="user.face || require('@/assets/pic3.png')" />
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="exit"><i class="el-icon-switch-button"></i>退出登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>

				<!-- <div> -->
				<!-- <el-badge :value="12" class="item" @click="clickDrawer">
          <img src="@/assets/tips.png" class="tips" @click="clickDrawer" />
        </el-badge> -->
				<!-- </div> -->
			</div>
		</el-header>
		<div class="drawer">
			<el-drawer title="我是标题" :visible.sync="drawer" :with-header="false" :modal-append-to-body="false">
				<div class="drawer-tab">
					<div class="act-sele" :class="drawerIndex == index ? 'masks' : ''" v-for="(item, index) in tabList"
						:key="item.id" @click="clickTab(index)">{{ item.text }}</div>
				</div>
				<div v-show="drawerIndex == 0">
					<el-empty description="这里空空如也"></el-empty>
				</div>
				<div v-show="drawerIndex == 1">
					<el-empty description="这里空空如也"></el-empty>
				</div>
			</el-drawer>
		</div>
		<div class="active">
			<el-drawer title="我是标题" :visible.sync="active" :with-header="false" :modal-append-to-body="false">
				<div class="drawer-tab">
					<div class="act-sele" :class="activeIndex == index ? 'masks' : ''" v-for="(item, index) in activeList"
						:key="item.id" @click="clickActive(index)">{{ item.text }}</div>
				</div>
				<div v-show="activeIndex == 0">
					<el-empty description="这里空空如也"></el-empty>
				</div>
				<div v-show="activeIndex == 1">
					<el-empty description="这里空空如也"></el-empty>
				</div>
				<div v-show="activeIndex == 2">
					<el-empty description="这里空空如也"></el-empty>
				</div>
			</el-drawer>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				drawer: false,
				drawerIndex: 0,
				active: false,
				activeIndex: 0,
				tabList: [{
						id: 0,
						text: '动态'
					},
					{
						id: 1,
						text: '与我相关'
					},
				],
				activeList: [{
						id: 0,
						text: '草稿箱'
					},
					{
						id: 1,
						text: '已发布'
					},

					{
						id: 2,
						text: '文章回收站'
					},
				],
				user:{},
				leftTop:''
			}
		},
		mounted() {
			this.user = JSON.parse(localStorage.getItem('user')) || {};
			this.leftTop = '社群工具'
		},
		methods: {
			goIndexView() {
				const { path } = this.$route
				if (path.startsWith('/index')) {
					// 在home页面（路由以/index开头）时，点击无反应
				} else {
					this.$router.push('/index')
				}
			},
			handleCommand(command) {
				console.log(command)
				switch (command) {
					case 'exit':
						localStorage.removeItem('user')
						localStorage.removeItem('groupitem')
						this.$router.push('/login')
						break
					case 'article':
						this.active = true
						break
					case 'footsteps':
						this.$router.push({
							name: 'FootSteps',
						})
						break
					case 'collect':
						console.log('我的收藏')
						this.$router.push('favorites')
						break
					case 'background':
						const {
							path
						} = this.$route
						if (path == '/homeview') {
							console.log('不动')
						} else {
							const routeData = this.$router.resolve({
								name: 'HomeView',
							})
							window.open(routeData.href, '_blank')
						}

						break
					default:
						break
				}
			},
			clickDrawer() {
				console.log(123)
				this.drawer = true
			},
			handleClick(tab, event) {
				console.log(tab, event)
			},
			clickTab(index) {
				this.drawerIndex = index
			},
			clickActive(index) {
				this.activeIndex = index
			},
		},
	}
</script>
<style lang="scss" scoped>
	.header {
		width: 100%;
	}
	
	.tag {
		background-color: #f57f59;
		color: #fff;
		margin: 0 20px;
		font-size: 14px;
		margin-bottom: -40px;
	}

	.el-header {
		color: #333;
		line-height: 60px;
		width: 100%;
		border-bottom: 1px solid #ededed;
		display: flex;
		justify-content: space-between;
		align-items: center;
		background-color: #fff;
		z-index: 9999999;

		.head-left {
			display: flex;
			align-items: center;
			cursor: pointer;

			.image {
				width: 40px;
				height: auto;
				padding: 0 10px;
			}

			.text {
				color: #333;
				font-size: 22px;
				font-weight: bold;
				margin-left: 5px;
			}

		}

		.head-right {
			display: flex;
			align-items: center;
			margin-bottom: 40px;

			.el-dropdown {
				height: 60px !important;
			}

			.img {
				width: 40px;
				height: auto;
				border-radius: 50px;
				margin: 30px 20px 0;
			}

			.menu {
				i {
					padding: 0 8px;
				}
			}

			.item {
				margin: 30px 40px 10px 10px;
				height: 19px;

				.tips {
					width: 30px;
					height: auto;
				}
			}
		}
	}

	.drawer-tab {
		padding: 20px 40px;
		width: 100%;
		display: flex;
		justify-content: space-around;
		font-size: 16px;
		border-bottom: 1px solid #f3f3f3;

		.act-sele {
			&.masks {
				color: #f57f59;
			}
		}
	}

	.el-tabs__nav {
		width: 100% !important;
	}
</style>